import React from "react";
import "../../Styles/GlobalStyles/printlayout.css";
import SAEDLOGO from "../../Assets/Logo/logo.png";
import { useSelector } from "react-redux";
import moment from "moment";

const PrintTemplate = () => {
  const getSkillSelectState = (state) => state.skillSelectReducer;
  const { skillSelectFetched } = useSelector(getSkillSelectState);
  const containerSection = {
    fontFamily: "Poppins, sans-serif",
  }
  const watermarkImg = {
    backgroundImage: `url(${SAEDLOGO})`,
    backgroundSize: "cover",
    backgroundRepeat: "no-repeat",
    opacity: "0.03",
    width: "50%",
    height: "auto",
    position: "absolute",
    top: "25%",
    left: "25%",
  };
  const nyscsaedlogoimg = {
    height: "70px",
    width: "auto",
  };

  const table = {
    fontFamily: "arial, sans-serif",
    borderCollapse: "collapse",
    width: "100%",
    "& td, thead": {
      border: "none",
      textAlign: "right",
      padding: "8px",
    },
  };

  const tdStyle = {
    // padding: "10px 0px",
  };
  const tdNumberStyle = {
    color:'#000',
    // textAlign:'right',
    //  padding: "10px 0px",
  }
  const trStyle = {
    backgroundColor: "none",
    borderbottom: "1px solid #e2e3e4",
    
  };
  const theadStyle = {
    color: "#05004E",
    fontWeight: 600,
  };
  const headerSection={
    display:'flex',
    justifyContent:'space-between',
    alignItems:'center'
  }
  const letterHeadSection = {
    display: "inline-flex",
    flexWrap: "wrap",
    gap: "8px",
    alignItems: "center",
    padding: "20px 0px",
  };

  const addressSection ={
    width:'300px',
    textAlign:'right',
    color: "#141213",
    fontWeight: "normal",
    lineHeight:'12px'
    // fontSize: "20px",
  }
  const saedText = {
    color: "#F0B811",
  };

  const h2Style = {
    color: "#141213",
    fontFamily: "Poppins, sans-serif",
    fontWeight: "bolder",
    fontSize: "20px",
  };

  const divider = {
    background: "#161616",
    width: "100vw",
    margin: "0px 10px",
  };

  const footerSpacer = {
    width: "100%",
    display: "block",
    height: "calc(20mm + 34px)",
  };

  const footer = {
    position: "fixed",
    bottom: 0,
    textAlign: "center",
    color: "white",
    width: "100%",
    padding: "30px",
    background: "#016C34 !important",
    WebkitPrintColorAdjust: "exact",
    height: "calc(20mm + 34px)",
  };

  return (
    <div style={containerSection}>
      <div style={headerSection}>
      <div style={letterHeadSection}>
        <div>
          <img style={nyscsaedlogoimg} src={SAEDLOGO} alt="SAED LOGO" />
        </div>
        <div className="text-section">
          <h2 style={h2Style}>
            NYSC <span style={saedText}>SAED</span>
          </h2>
        </div>
      </div>
      <div style={addressSection}>
          <h6>
            NYSC Secretariat : No. 6 Lasale Street Off Shehu Shagari way
            Maitama, beside CBN Training centre, Abuja <br/> Tel: 08035909473 <br/> Email:
            fct@nysc.gov.ng
          </h6>
        </div>
      </div>
      <hr style={divider} />
      <br />
      <br />
      <div className="watermark">
        <img style={watermarkImg} src={SAEDLOGO} alt="SAED LOGO" />
      </div>
      <div id="content">
        <table style={table}>
          <thead style={theadStyle}>
            <tr style={trStyle}>
              <td style={tdStyle}>Skills</td>
              <td style={tdStyle}>No of Sub Skills</td>
              <td style={tdStyle}>Date Created</td>
              <td style={tdStyle}>Status</td>
            </tr>
          </thead>
          <tbody>
            {skillSelectFetched?.map((item, index) => {
              return (
                <tr key={index} style={trStyle}>
                  <td style={tdStyle}>{item.name}</td>
                  <td style={tdNumberStyle}>{item.subSkills.length}</td>
                  <td style={tdStyle}>
                    {moment(item.dateCreated).format("DD/MM/YYYY")}
                  </td>
                  <td style={tdStyle}>
                    {item.isActive === true ? "Active" : "Inactive"}
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
      <div className="footerPrint" style={footerSpacer}></div>
      <footer className="footerPrint" style={footer}>
        <p>
          Plot 416, Tigris Cresent Off Aguiyi Ironsi Street, Maitama.PMB 138,
          Garki ,Abuja.
        </p>
        <p>Email: info@nysc.gov.ng </p>
      </footer>
    </div>
  );
};

export default PrintTemplate;
